import PIXI from 'pixi.js/src';
import data from './../data/data';
import config from './../config/config';
import router from './../router/router';
import renderHelper from './../helpers/render';
import frameAnimationHelper from './../helpers/frame-animation';
import GameStore from './../stores/GameStore';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';


const interstitialView = {
  textLetterInt: 0,
  writeTextInterval: 0,


  /**
   * Sets up the view
   * @param {Object} params - Data for the view
   * @returns {undefined} undefined
   */
  init(params) {
    this.interstitialDataProperty = 'interstitial' + params.level + 'Data';
    this.randomTextInt = Math.floor(Math.random() *
      ((data[this.interstitialDataProperty].text.length) - 0)) + 0;

    const nextLevel = data[this.interstitialDataProperty].level + 1;

    this.backgroundSquare = new PIXI.Graphics();
    this.backgroundSquare.beginFill(
      data[this.interstitialDataProperty].backgroundColor, 1);
    this.backgroundSquare.drawRect(
      0,
      0,
      window.innerWidth,
      window.innerHeight);
    renderHelper.stage.addChild(this.backgroundSquare);

    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);

    frameAnimationHelper.create(
      this.graphicsContainer,
      data[this.interstitialDataProperty].imagePaths,
      data[this.interstitialDataProperty].animationTime,
      true,
      data[this.interstitialDataProperty].imageWidth,
      data[this.interstitialDataProperty].imageHeight);

    this.messageText = new PIXI.Text('',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
        align: 'center',
      }
    );
    this.messageText.resolution = 2;
    renderHelper.stage.addChild(this.messageText);

    this.continueButton = new PIXI.Text('PLAY LEVEL ' + nextLevel + ' >',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.continueButton.resolution = 2;
    this.continueButton.alpha = 0;
    renderHelper.stage.addChild(this.continueButton);
    this.continueButton.interactive = true;

    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);

    this.positionGraphics();

    this.writeTextInterval = setInterval(this.writeOutText.bind(this), 50);
  },


  /**
   * Writes out the text
   * @returns {undefined} undefined
   */
  writeOutText() {
    const currentText =
      data[this.interstitialDataProperty].text[this.randomTextInt];
    this.textLetterInt++;
    const newText = currentText.slice(0, this.textLetterInt).toUpperCase();

    this.messageText.text = newText;

    if (this.textLetterInt === currentText.length) {
      clearInterval(this.writeTextInterval);

      document.addEventListener('touchend', this.onButtonClick);

      this.tween = window.TweenLite.to(
        this.continueButton,
        0.5,
        {
          autoKill: true,
          alpha: 1,
          ease: window.Linear.easeNone,
        }
      );
    }

    this.positionGraphics();
  },


  /**
   * Click handler for the replay button
   * @returns {undefined} undefined
   */
  onButtonClick() {
    const nextLevel = Number(GameStore.getState().currentLevelData.level + 1);

    AppDispatcher.handleViewAction({
      actionType: AppConstants.SET_LEVEL,
      level: nextLevel,
    });

    setTimeout(() => {
      router.navigate('game');
    }, 10);
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    let graphicsY;

    if (data[this.interstitialDataProperty].level !== 2) {
      graphicsY = Math.round(window.innerHeight -
        data[this.interstitialDataProperty].imageHeight);
      if (graphicsY < 120) {
        graphicsY = 120;
      }
    } else {
      graphicsY = 0;
      if (data[this.interstitialDataProperty].imageHeight >
        window.innerHeight - 120) {
        graphicsY = (window.innerHeight - 120) -
          data[this.interstitialDataProperty].imageHeight;
      }
    }

    this.backgroundSquare.height = window.innerHeight;

    this.graphicsContainer.x =
      Math.round((window.innerWidth / 2) -
      (data[this.interstitialDataProperty].imageWidth / 2));
    this.graphicsContainer.y = graphicsY;

    this.messageText.x =
      Math.round((window.innerWidth / 2) - (this.messageText.width / 2));

    if (data[this.interstitialDataProperty].level !== 2) {
      this.messageText.y = 20;
    } else {
      this.messageText.y = window.innerHeight - 130;
    }

    this.continueButton.x =
      Math.round((window.innerWidth / 2) - (this.continueButton.width / 2));
    this.continueButton.y =
      Math.round(this.messageText.y + this.messageText.height + 10);
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    clearInterval(this.writeTextInterval);
    document.removeEventListener('touchend', this.onButtonClick);
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
    renderHelper.stage.removeChild(this.graphicsContainer);
    renderHelper.stage.removeChild(this.backgroundSquare);
    this.continueButton.off('touchstart', this.onButtonClick);
    this.continueButton.off('mousedown', this.onButtonClick);
    renderHelper.stage.removeChild(this.continueButton);
    renderHelper.stage.removeChild(this.messageText);
    frameAnimationHelper.destroyAllAnimations();
  },
};

export default interstitialView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/interstitial.js
 **/